export default {
  state() {
    return {
      user: undefined, // KHÔNG SET TRƯỜNG NÀY, TRƯỜNG NÀY LẤY TỪ COOKIE DO BÊN TOP SET
      profileMe: undefined, // GET TỪ API profile/me
      authenticate: undefined,
      lastUserOperationDate: null,
      subscriptions: null,
      rakuten_access_token: undefined,
      loggedIn: undefined
    }
  },
  getters: {
    get(state) {
      return state
    }
  },
  mutations: {
    set(state, { user, subscriptions }) {
      if (user) {
        state.user = user
      }
      if (subscriptions) {
        state.subscriptions = subscriptions
      }
    },
    setProfileMe(state, payload) {
      state.profileMe = payload
    },
    removeUser(state) {
      state.user = undefined
    },
    setRakutenToken(state, { rakuten_access_token }) {
      if (rakuten_access_token) {
        state.rakuten_access_token = rakuten_access_token
      }
    },
    remove(state) {
      state.user = undefined
    },
    setLastUserOperationDate(state, value) {
      state.lastUserOperationDate = value
    },
    setLoggedIn(state, value) {
      state.loggedIn = value
    }
  },
  actions: {
    setState({ commit }, payload) {
      commit('set', payload)
    },
    setRakutenToken({ commit }, payload) {
      commit('setRakutenToken', payload)
    }
  }
}
